import Glide from '@glidejs/glide';

let glide = new Glide('.glide-photos', {
  type: 'carousel',
  perView: 2,
  focusAt: 'center',
  gap: 24,
  breakpoints: {
    900: {
      perView: 1,
      peek: 0,
    },
  },
});
glide.mount();

let glideMemorial = new Glide('.glide-memorial', {
  type: 'carousel',
  perView: 2,
  focusAt: 'center',
  gap: 24,
  breakpoints: {
    900: {
      perView: 1,
      peek: 0,
    },
  },
});
glideMemorial.mount();


let glideEndorsements = new Glide('.glide-endorsements', {
  type: 'slider',
  perView: 4,
  gap: 24,
  bound: true,
  breakpoints: {
    1639: {
      perView: 3
    },
    1241: {
      perView: 2
    },
    850: {
      perView: 1
    }

  },
});
glideEndorsements.mount();

// Select only elements that explicitly request Glide
  const glideEls = document.querySelectorAll("[data-glide-mobile]");

  if (glideEls.length) {

    glideEls.forEach((el) => {
      if (!el || !el.dataset) return;
      // Prevent duplicate mounting
      if (el.dataset.glideMounted === "true") return;

      const type = el.dataset.type || "slider";
      const perView = parseInt(el.dataset.perView) || 1;
      const gap = parseInt(el.dataset.gap) || 0;
      const breakpoint = parseInt(el.dataset.breakpoint) || null;

      let glideInstance = null;

      function mount() {
        if (glideInstance) return;
        glideInstance = new Glide(el, { type, perView, gap });
        glideInstance.mount();
        el.dataset.glideMounted = "true";
      }

      function destroy() {
        if (!glideInstance) return;
        glideInstance.destroy();
        glideInstance = null;
        el.dataset.glideMounted = "false";
      }

      // If no breakpoint set → always on
      if (!breakpoint) {
        mount();
        return;
      }

      // Breakpoint logic
      const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);

      function handle(e) {
        e.matches ? mount() : destroy();
      }

      handle(mq);
      mq.addEventListener("change", handle);
    });

  }
